import { Component, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { RestService, StorageService } from '../../services';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

@Component({
  selector: 'newgasarticles',
  providers: [RestService, StorageService],
  templateUrl: './newgasarticles.component.html',
  styleUrls: ['./newgasarticles.component.scss']
})
export class NewGasArticlesComponent {

  private articles: any[] = [];
  private articleReference: string;

  @Input("projectId") public projectId: number;
  @Input("parcelCode") public parcelCode: string;
  @Output("onSave") onSave = new EventEmitter<any>();
  @Output("onCancel") onCancel = new EventEmitter<any>();

  constructor(
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _restService: RestService,
    private _storageService: StorageService,
    public media: TdMediaService) {
  }

  ngOnChanges(changes: any) {
    if (this.projectId != null) {
      this.load();
    }
  }

  confirm() {
    this.onSave.emit(this.articles); 
    this.articles = [];                
  }

  cancel() {
    this.articles = [];
    this.onCancel.emit(this.articles);
  }

  async loadArticle(articleReference: string): Promise<void> {
    try {

      let article = {
        reference : articleReference
      }
      this.articles.push(article);
      this.articleReference = null;

    } catch (error) {
      this.articleReference = null;
      this._dialogService.openAlert({ message: 'could not load article to the list for trackikng' + this.parcelCode });
    } finally {

    }
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('article.list');
      
    } catch (error) {
    } finally {
      this._loadingService.resolve('article.list');
    }
  }

  keytab(event, from: string, innerText: string) {
    if (from == 'articleReference') {
      this.loadArticle(this.articleReference);
    }

    let path = event.composedPath();
    let element = path[5]; // naviagte to md-card-content

    let child;

      for (let j = 0; j < element.children.length; j++) {
        if (element.children[j].innerText == innerText) { // navigate to md-input-container with the given text
          child = element.children[j].children[0].children[0].children[0].children[0]; // navigate to input area where value is entered
        }
      }

    if(child == null)  // check if its null
        return;
    else
      child.focus();   // focus if not null
        return;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/gas/gasArticles/newgasarticles.component.ts